import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, InstallDatePanelInfo } from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class InstallDatePanelService {
  private readonly sdk: ApiClient = inject(ApiClient);

  getPanel(opportunityId: string, startDate: Date, endDate: Date): Observable<InstallDatePanelInfo> {
    return this.sdk.getInstallDatePanel(opportunityId, startDate, endDate);
  }
}
